import React from 'react';
import './BusinessCard.scss';
import { UserRole, type User } from '@/modules/user/userTypes';
import { Business } from '@/modules/dashboard/dashboardTypes';

interface BusinessCardProps {
	business: Business;
	onClose: () => void;
	onTabClick: () => void;
	user: User;
}

const BusinessCard: React.FC<BusinessCardProps> = ({
	business,
	onClose,
	onTabClick,
	user
}) => {
	const isContacted = method => business?.isContacted?.[method] || false;
	const isUserFreeTier = user.role !== UserRole.Free && user.role !== UserRole.PreTrial;

	return (
		<div className="business-card-container">
			{/* Close Button for Entire Card */}
			<button
				type="button"
				className="business-card-close-button"
				onClick={onClose}
			>
				✕
			</button>
			<div className="business-card-content" onClick={onTabClick}>
				<h2 className="business-name">{business.name}</h2>

				{/* Contact Methods as Individual Cards */}
				<div
					data-freeTier={isUserFreeTier}
					className="contact-methods-column data-[freeTier=true]:blur-sm"
				>
					{/* Emails as individual cards */}
					{business.emails &&
						business.emails.map((email, index) => (
							<div
								key={index}
								className={`contact-method card ${
									isContacted('email') ? 'contacted' : ''
								}`}
							>
								<span>{email}</span>
							</div>
						))}

					{/* Facebook */}
					{business.facebookUrl && (
						<div
							className={`contact-method card ${
								isContacted('facebook') ? 'contacted' : ''
							}`}
						>
							<a
								href={business.facebookUrl}
								target="_blank"
								rel="noopener noreferrer"
							>
								Facebook
							</a>
						</div>
					)}

					{/* Instagram */}
					{business.instagramUrl && (
						<div
							className={`contact-method card ${
								isContacted('instagram') ? 'contacted' : ''
							}`}
						>
							<a
								href={business.instagramUrl}
								target="_blank"
								rel="noopener noreferrer"
							>
								Instagram
							</a>
						</div>
					)}

					{/* Phone as an individual card */}
					{business.phone && (
						<div
							className={`contact-method card ${
								isContacted('phone') ? 'contacted' : ''
							}`}
						>
							<span>{business.phone}</span>
						</div>
					)}
				</div>
				{/* Add address */}
				{business.address && (
					<div className="business-card-address">
						<span className="address-label">Address</span>
						<span>{business.address}</span>
					</div>
				)}
				{/* Add Categories */}
				{business.categories && (
					<div className="business-card-categories">
						<span className="category-label">Categories</span>
						<div className="category-cards-container">
							{business.categories.map((category, index) => (
								<div key={index} className="category-card">
									<span>{category}</span>
								</div>
							))}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default BusinessCard;
